import { useEffect, useRef } from 'react';

declare const bootstrap: any;

function Tooltip({ children, title, className = '' }: any) {
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (domRef.current && title) {
      const tooltip = new bootstrap.Tooltip(domRef.current);
      return () => tooltip.dispose();
    }
  }, [title]);

  return (
    <div
      {...(title ? { 'data-bs-toggle': 'tooltip', title } : {})}
      ref={domRef}
      className={className}
      role="tooltip"
    >
      {children}
    </div>
  );
}

export default Tooltip;
